import { CreateGUFHeightTask, EditGUFHeightTask } from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

export const realisedScreenChangesSchema = addSchema<
  (CreateGUFHeightTask | EditGUFHeightTask)["sourcedocumentData"]["realisedScreens"]
>({
  type: "array",
  title: "Gerealiseerde filterwijzigingen",
  minItems: 0,
  items: {
    type: "object",
    title: "Filterwijziging",
    required: ["realisedScreenId", "topScreenDepth"],
    properties: pickGufPrimitiveLibraryFields(["realisedScreenId", "topScreenDepth"]),
  },
});
